export const NUMBER_ZERO = 0;
export const NUMBER_ONE = 1;
export const NUMBER_TWO = 2;
export const NUMBER_THREE = 3;
export const NUMBER_FOUR = 4;
export const NUMBER_FIVE = 5;
export const NUMBER_SIX = 6;
export const NUMBER_SEVEN = 7;
export const NUMBER_EIGHT = 8;
export const NUMBER_NINE = 9;
export const NUMBER_TEN = 10;
export const ARRAY_HAS_NO_LENGTH = 0;
export const API_CALL_SUCCESS = 200;

export const CURRENCY_CODE = "INR";

export default {
  NUMBER_ZERO,
  NUMBER_ONE,
  NUMBER_TWO,
  NUMBER_THREE,
  NUMBER_FOUR,
  NUMBER_FIVE,
  NUMBER_SIX,
  NUMBER_SEVEN,
  NUMBER_EIGHT,
  NUMBER_NINE,
  NUMBER_TEN,
  ARRAY_HAS_NO_LENGTH,
  API_CALL_SUCCESS,
  CURRENCY_CODE,
};